import { render } from "./BookingAssistPanel.vue?vue&type=template&id=6281ab5b&scoped=true"
import script from "./BookingAssistPanel.vue?vue&type=script&lang=js"
export * from "./BookingAssistPanel.vue?vue&type=script&lang=js"

import "./BookingAssistPanel.vue?vue&type=style&index=0&id=6281ab5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6281ab5b"]])

export default __exports__